import { getCookie } from './getCookie';
export function shouldShowFullscreenBanner() {
  return getCookie('number_banner_appearances') !== '1';
}